import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { routes } from "../routes/routes";
import "../styles/LandingPage.css";
import {
  FaAngleRight,
  FaCommentDots,
  FaMapLocationDot,
  FaMapPin,
  FaPlane,
} from "react-icons/fa6";

const LandingPage = () => {
  const [modalImage, setModalImage] = useState<string | null>(null);
  const [content, setContent] = useState<any>(null);

  const handleImageClick = (imgUrl: string) => {
    setModalImage(imgUrl);
  };

  const closeModal = () => setModalImage(null);

  const texts = {
    fr: {
      title: "Planifiez votre voyage avec l'aide de l’IA",
      subtitle:
        "Une application intelligente pour organiser votre voyage idéal: itinéraires, transports, hébergements, location de voiture, activités…",
      cta: "Je m’inscris gratuitement",
      features: [
        {
          icon: <FaCommentDots />,
          title: "Assistant de voyage IA",
          desc: "Discutez avec un assistant intelligent pour imaginer votre voyage idéal.",
          img: "/screenshots/chat_ai_assistant.jpg",
        },
        {
          icon: <FaMapLocationDot />,
          title: "Générateur d’itinéraire",
          desc: "Créez un parcours personnalisé selon vos envies et contraintes.",
          img: "/screenshots/itinerary_chat.jpg",
        },
        {
          icon: <FaPlane />,
          title: "Transport, Hôtels & Activités",
          desc: "Comparez et réservez directement ce dont vous avez besoin.",
          img: "/screenshots/transport_panel.jpg",
        },
        {
          icon: <FaMapPin />,
          title: "Cartographie interactive",
          desc: "Visualisez votre itinéraire, vos étapes et suggestions sur la carte.",
          img: "/screenshots/itinerary_page.jpg",
        },
      ],

      bottom: "Vous cherchez une nouvelle façon de planifier vos voyages ?",
      bottom_description: [
        "L’app n’est pas encore en ligne, mais on y travaille dur !",
        "On cherche des voyageurs curieux et motivés pour tester les premières versions et nous dire ce qui compte vraiment pour eux.",
        "En vous créant votre compte gratuitement, vous nous aidez à créer l’outil de voyage idéal et à façonner avec nous l'avenir du travel planning.",
      ],
    },
    en: {
      title: "Plan your trip with AI",
      subtitle:
        "An intelligent application to organise your ideal trip: itineraries, transport, accommodation, car hire, activities, etc.",
      cta: "I'm signing up for free",
      features: [
        {
          icon: <FaCommentDots />,
          title: "AI travel assistant",
          desc: "Chat with an intelligent assistant to plan your ideal trip.",
          img: "/screenshots/chat_ai_assistant.jpg",
        },
        {
          icon: <FaMapLocationDot />,
          title: "Travel planner",
          desc: "Create a personalised route according to your preferences and constraints.",
          img: "/screenshots/itinerary_chat.jpg",
        },
        {
          icon: <FaPlane />,
          title: "Transport, Hotels & Activities",
          desc: "Compare and book directly what you need.",
          img: "/screenshots/transport_panel.jpg",
        },
        {
          icon: <FaMapPin />,
          title: "Interactive mapping",
          desc: "View your itinerary, stops and suggestions on the map.",
          img: "/screenshots/itinerary_page.jpg",
        },
      ],

      bottom: "Are you looking for a new way to plan your trips?",
      bottom_description: [
        "The app isn't online yet, but we're working hard on it!",
        "We're looking for curious and motivated travellers to test the first versions and tell us what really matters to them.",
        "By creating your free account, you'll be helping us to create the ideal travel tool and shape the future of travel planning with us.",
      ],
    },
    nl: {
      title: "Plan je reis met behulp van AI",
      subtitle:
        "Een slimme app om je ideale reis te organiseren: routes, vervoer, accommodaties, autohuur, activiteiten…",
      cta: "Ik meld me gratis aan",
      features: [
        {
          icon: <FaCommentDots />,
          title: "AI-reisassistent",
          desc: "Praat met een slimme assistent om je ideale reis uit te denken.",
          img: "/screenshots/chat_ai_assistant.jpg",
        },
        {
          icon: <FaMapLocationDot />,
          title: "Route‑generator",
          desc: "Maak een gepersonaliseerde route op basis van je wensen en beperkingen.",
          img: "/screenshots/itinerary_chat.jpg",
        },
        {
          icon: <FaPlane />,
          title: "Vervoer, hotels & activiteiten",
          desc: "Vergelijk en boek direct wat je nodig hebt.",
          img: "/screenshots/transport_panel.jpg",
        },
        {
          icon: <FaMapPin />,
          title: "Interactieve kaart",
          desc: "Bekijk je route, stops en suggesties op de kaart.",
          img: "/screenshots/itinerary_page.jpg",
        },
      ],
      bottom: "Ben je op zoek naar een nieuwe manier om je reizen te plannen?",
      bottom_description: [
        "De app is nog niet live, maar we werken er hard aan!",
        "We zoeken nieuwsgierige en gemotiveerde reizigers om de eerste versies te testen en ons te vertellen wat écht telt voor hen.",
        "Door gratis een account aan te maken, help je ons om de ideale reisplanner te bouwen en samen de toekomst van reisplanning te vormen.",
      ],
    },
    de: {
      title: "Plane dein Reise mit KI‑Hilfe",
      subtitle:
        "Eine intelligente App, um deine ideale Reise zu planen: Routen, Transport, Unterkünfte, Mietwagen, Aktivitäten…",
      cta: "Ich melde mich kostenlos an",
      features: [
        {
          icon: <FaCommentDots />,
          title: "KI‑Reiseassistent",
          desc: "Unterhalte dich mit einem intelligenten Assistenten, um deine Traumreise zu entwickeln.",
          img: "/screenshots/chat_ai_assistant.jpg",
        },
        {
          icon: <FaMapLocationDot />,
          title: "Routen‑Generator",
          desc: "Erstelle eine personalisierte Route nach deinen Wünschen und Vorgaben.",
          img: "/screenshots/itinerary_chat.jpg",
        },
        {
          icon: <FaPlane />,
          title: "Transport, Hotels & Aktivitäten",
          desc: "Vergleiche und buche direkt, was du brauchst.",
          img: "/screenshots/transport_panel.jpg",
        },
        {
          icon: <FaMapPin />,
          title: "Interaktive Karte",
          desc: "Sieh deine Route, Etappen und Vorschläge auf der Karte.",
          img: "/screenshots/itinerary_page.jpg",
        },
      ],
      bottom: "Suchst du nach einer neuen Art, deine Reisen zu planen?",
      bottom_description: [
        "Die App ist noch nicht online, aber wir arbeiten hart daran!",
        "Wir suchen neugierige und motivierte Reisende, die unsere ersten Versionen testen und uns sagen, was wirklich zählt.",
        "Mit einem kostenlosen Konto hilfst du uns, das ideale Reise-Tool zu entwickeln und mit uns die Zukunft der Reiseplanung zu gestalten.",
      ],
    },
    it: {
      title: "Pianifica il tuo viaggio con l’aiuto dell’IA",
      subtitle:
        "Un’app intelligente per organizzare il viaggio ideale: itinerari, trasporti, alloggi, auto a noleggio, attività…",
      cta: "Mi iscrivo gratuitamente",
      features: [
        {
          icon: <FaCommentDots />,
          title: "Assistente di viaggio IA",
          desc: "Parla con un assistente intelligente per immaginare il tuo viaggio ideale.",
          img: "/screenshots/chat_ai_assistant.jpg",
        },
        {
          icon: <FaMapLocationDot />,
          title: "Generatore di itinerari",
          desc: "Crea un percorso personalizzato secondo i tuoi desideri e vincoli.",
          img: "/screenshots/itinerary_chat.jpg",
        },
        {
          icon: <FaPlane />,
          title: "Trasporti, hotel & attività",
          desc: "Confronta e prenota direttamente ciò che ti serve.",
          img: "/screenshots/transport_panel.jpg",
        },
        {
          icon: <FaMapPin />,
          title: "Mappa interattiva",
          desc: "Visualizza il tuo itinerario, le tappe e i suggerimenti sulla mappa.",
          img: "/screenshots/itinerary_page.jpg",
        },
      ],
      bottom: "Cerchi un nuovo modo per pianificare i tuoi viaggi?",
      bottom_description: [
        "L’app non è ancora online, ma ci stiamo lavorando duramente!",
        "Cerchiamo viaggiatori curiosi e motivati per testare le prime versioni e dirci cosa conta davvero per loro.",
        "Creando un account gratuito ci aiuti a costruire lo strumento di viaggio ideale e a plasmare con noi il futuro del travel planning.",
      ],
    },
    es: {
      title: "Planifica tu viaje con ayuda de la IA",
      subtitle:
        "Una app inteligente para organizar tu viaje ideal: itinerarios, transporte, alojamientos, coche de alquiler, actividades…",
      cta: "Me inscribo gratis",
      features: [
        {
          icon: <FaCommentDots />,
          title: "Asistente de viaje IA",
          desc: "Chatea con un asistente inteligente para imaginar tu viaje ideal.",
          img: "/screenshots/chat_ai_assistant.jpg",
        },
        {
          icon: <FaMapLocationDot />,
          title: "Generador de itinerario",
          desc: "Crea una ruta personalizada según tus deseos y restricciones.",
          img: "/screenshots/itinerary_chat.jpg",
        },
        {
          icon: <FaPlane />,
          title: "Transporte, hoteles & actividades",
          desc: "Compara y reserva directamente lo que necesitas.",
          img: "/screenshots/transport_panel.jpg",
        },
        {
          icon: <FaMapPin />,
          title: "Mapa interactivo",
          desc: "Visualiza tu itinerario, paradas y sugerencias en el mapa.",
          img: "/screenshots/itinerary_page.jpg",
        },
      ],
      bottom: "¿Buscas una nueva forma de planear tus viajes?",
      bottom_description: [
        "La app aún no está en línea, ¡pero estamos trabajando duro!",
        "Buscamos viajeros curiosos y motivados para probar las primeras versiones y contarnos qué realmente importa para ellos.",
        "Al crear tu cuenta gratis, nos ayudas a construir la herramienta de viaje ideal y a moldear con nosotros el futuro del travel planning.",
      ],
    },
    pt: {
      title: "Planifica a tua viagem com ajuda da IA",
      subtitle:
        "Uma app inteligente para organizares a viagem ideal: itinerários, transportes, alojamentos, aluguer de carro, atividades…",
      cta: "Inscrevo‑me gratuitamente",
      features: [
        {
          icon: <FaCommentDots />,
          title: "Assistente de viagem IA",
          desc: "Conversa com um assistente inteligente para imaginar a tua viagem ideal.",
          img: "/screenshots/chat_ai_assistant.jpg",
        },
        {
          icon: <FaMapLocationDot />,
          title: "Gerador de itinerários",
          desc: "Cria um percurso personalizado segundo os teus desejos e restrições.",
          img: "/screenshots/itinerary_chat.jpg",
        },
        {
          icon: <FaPlane />,
          title: "Transportes, hotéis & atividades",
          desc: "Compara e reserva diretamente o que precisas.",
          img: "/screenshots/transport_panel.jpg",
        },
        {
          icon: <FaMapPin />,
          title: "Mapa interativo",
          desc: "Vê o teu itinerário, paragens e sugestões no mapa.",
          img: "/screenshots/itinerary_page.jpg",
        },
      ],
      bottom: "Procuras uma nova forma de planear as tuas viagens?",
      bottom_description: [
        "A app ainda não está online, mas estamos a trabalhar arduamente!",
        "Procuramos viajantes curiosos e motivados para testarem as primeiras versões e nos dizerem o que realmente importa para eles.",
        "Ao criares a tua conta gratuita, ajudas-nos a criar a ferramenta de viagem ideal e a construir connosco o futuro do travel planning.",
      ],
    },
    fi: {
      title: "Suunnittele matkasi tekoälyn avulla",
      subtitle:
        "Älykäs sovellus ihanteellisen matkan järjestämiseen: reitit, kuljetukset, majoitus, autonvuokraus, aktiviteetit…",
      cta: "Rekisteröidyn ilmaiseksi",
      features: [
        {
          icon: <FaCommentDots />,
          title: "Tekoälymatka‑assistentti",
          desc: "Keskustele älykkään avustajan kanssa ja kuvittele unelmiesi matka.",
          img: "/screenshots/chat_ai_assistant.jpg",
        },
        {
          icon: <FaMapLocationDot />,
          title: "Reittigeneraattori",
          desc: "Luo personoitu reitti toiveidesi ja rajoitteidesi mukaan.",
          img: "/screenshots/itinerary_chat.jpg",
        },
        {
          icon: <FaPlane />,
          title: "Kuljetus, hotellit & aktiviteetit",
          desc: "Vertaa ja varaa suoraan tarvittava.",
          img: "/screenshots/transport_panel.jpg",
        },
        {
          icon: <FaMapPin />,
          title: "Interaktiivinen kartta",
          desc: "Näe reittisi, pysähdykset ja ehdotukset kartalla.",
          img: "/screenshots/itinerary_page.jpg",
        },
      ],
      bottom: "Etsitkö uutta tapaa suunnitella matkojasi?",
      bottom_description: [
        "Sovellus ei ole vielä netissä, mutta teemme kovasti töitä sen eteen!",
        "Etsimme uteliaita ja motivoituneita matkustajia testaamaan ensimmäisiä versioita ja kertomaan, mikä heille todella merkitsee.",
        "Kun luot ilmaisen tilin, autat meitä rakentamaan ihanteellisen matkal työkalun ja muokkaamaan matkasuunnittelun tulevaisuutta kanssamme.",
      ],
    },
    ro: {
      title: "Planifică-ți călătoria cu ajutorul IA",
      subtitle:
        "O aplicație inteligentă pentru organizarea călătoriei ideale: itinerarii, transport, cazări, închiriere mașină, activități…",
      cta: "Mă înscriu gratuit",
      features: [
        {
          icon: <FaCommentDots />,
          title: "Asistent de călătorie IA",
          desc: "Vorbește cu un asistent inteligent pentru a-ți imagina călătoria ideală.",
          img: "/screenshots/chat_ai_assistant.jpg",
        },
        {
          icon: <FaMapLocationDot />,
          title: "Generator de itinerariu",
          desc: "Creează un traseu personalizat conform dorințelor și constrângerilor tale.",
          img: "/screenshots/itinerary_chat.jpg",
        },
        {
          icon: <FaPlane />,
          title: "Transport, hoteluri & activități",
          desc: "Compară și rezervă direct ce ai nevoie.",
          img: "/screenshots/transport_panel.jpg",
        },
        {
          icon: <FaMapPin />,
          title: "Hartă interactivă",
          desc: "Vizualizează itinerariul, opririle și sugestiile pe hartă.",
          img: "/screenshots/itinerary_page.jpg",
        },
      ],
      bottom: "Cauți o nouă modalitate de a‑ți planifica călătoriile?",
      bottom_description: [
        "Aplicația nu este încă online, dar lucrăm din greu pentru ea!",
        "Căutăm călători curioși și motivați să testeze primele versiuni și să ne spună ce contează cu adevărat pentru ei.",
        "Creând un cont gratuit, ne ajuți să construim instrumentul ideal de planificare a călătoriilor și să modelăm cu noi viitorul travel planning‑ului.",
      ],
    },
    hr: {
      title: "Isplanirajte svoje putovanje uz pomoć AI",
      subtitle:
        "Pametna aplikacija za organizaciju vašeg idealnog putovanja: itinereri, prijevoz, smještaj, najam automobila, aktivnosti…",
      cta: "Besplatno se prijavljujem",
      features: [
        {
          icon: <FaCommentDots />,
          title: "AI‑putnički asistent",
          desc: "Razgovarajte s pametnim asistentom kako biste osmislili svoje idealno putovanje.",
          img: "/screenshots/chat_ai_assistant.jpg",
        },
        {
          icon: <FaMapLocationDot />,
          title: "Generator itinerera",
          desc: "Stvorite personaliziranu rutu prema vašim željama i ograničenjima.",
          img: "/screenshots/itinerary_chat.jpg",
        },
        {
          icon: <FaPlane />,
          title: "Prijevoz, hoteli & aktivnosti",
          desc: "Usporedite i rezervirajte direktno što vam treba.",
          img: "/screenshots/transport_panel.jpg",
        },
        {
          icon: <FaMapPin />,
          title: "Interaktivna karta",
          desc: "Prikaz itinerera, etapa i prijedloga na karti.",
          img: "/screenshots/itinerary_page.jpg",
        },
      ],
      bottom: "Tražite novi način planiranja svojih putovanja?",
      bottom_description: [
        "Aplikacija još nije online, ali naporno radimo na njoj!",
        "Tražimo radoznale i motivirane putnike koji će testirati prve verzije i reći nam što im stvarno znači.",
        "Kreiranjem besplatnog računa pomažete nam izgraditi idealni alat za putovanja i oblikovati budućnost travel planninga s nama.",
      ],
    },
    cs: {
      title: "Naplánujte si cestu s pomocí AI",
      subtitle:
        "Chytrá aplikace pro organizaci vaší ideální cesty: trasy, doprava, ubytování, půjčení auta, aktivity…",
      cta: "Zaregistruji se zdarma",
      features: [
        {
          icon: <FaCommentDots />,
          title: "Cestovní AI asistent",
          desc: "Komunikujte s chytrým asistentem a vymyslete svou ideální cestu.",
          img: "/screenshots/chat_ai_assistant.jpg",
        },
        {
          icon: <FaMapLocationDot />,
          title: "Generátor tras",
          desc: "Vytvořte si personalizovanou trasu podle svých přání a omezení.",
          img: "/screenshots/itinerary_chat.jpg",
        },
        {
          icon: <FaPlane />,
          title: "Doprava, hotely & aktivity",
          desc: "Porovnejte a rezervujte přímo, co potřebujete.",
          img: "/screenshots/transport_panel.jpg",
        },
        {
          icon: <FaMapPin />,
          title: "Interaktivní mapa",
          desc: "Zobrazte si trasu, zastávky a návrhy na mapě.",
          img: "/screenshots/itinerary_page.jpg",
        },
      ],
      bottom: "Hledáte nový způsob, jak plánovat své cesty?",
      bottom_description: [
        "Aplikace ještě není online, ale pracujeme na ní usilovně!",
        "Hledáme zvědavé a motivované cestovatele, kteří otestují první verze a řeknou nám, co je pro ně opravdu důležité.",
        "Založením bezplatného účtu nám pomáháte vytvořit ideální cestovatelský nástroj a formovat s námi budoucnost plánování cest.",
      ],
    },
    sv: {
      title: "Planera din resa med hjälp av AI",
      subtitle:
        "En smart app för att organisera din drömresa: rutter, transporter, boende, biluthyrning, aktiviteter…",
      cta: "Jag registrerar mig gratis",
      features: [
        {
          icon: <FaCommentDots />,
          title: "AI‑reseassistent",
          desc: "Prata med en intelligent assistent för att föreställa dig din drömresa.",
          img: "/screenshots/chat_ai_assistant.jpg",
        },
        {
          icon: <FaMapLocationDot />,
          title: "Ruttgenerator",
          desc: "Skapa en personlig rutt baserad på dina önskemål och begränsningar.",
          img: "/screenshots/itinerary_chat.jpg",
        },
        {
          icon: <FaPlane />,
          title: "Transport, hotell & aktiviteter",
          desc: "Jämför och boka direkt det du behöver.",
          img: "/screenshots/transport_panel.jpg",
        },
        {
          icon: <FaMapPin />,
          title: "Interaktiv karta",
          desc: "Visa din rutt, stopp och förslag på kartan.",
          img: "/screenshots/itinerary_page.jpg",
        },
      ],
      bottom: "Letar du efter ett nytt sätt att planera dina resor?",
      bottom_description: [
        "Appen är inte live än, men vi jobbar hårt på den!",
        "Vi söker nyfikna och motiverade resenärer som vill testa våra första versioner och berätta vad som verkligen betyder något för dem.",
        "Genom att skapa ett gratis konto hjälper du oss bygga det perfekta resverktyget och forma framtiden för reseplanering tillsammans med oss.",
      ],
    },
    pl: {
      title: "Zaplanuj swoją podróż z pomocą AI",
      subtitle:
        "Inteligentna aplikacja do organizacji idealnej podróży: trasy, transport, zakwaterowanie, wypożyczalnia samochodów, atrakcje…",
      cta: "Rejestruję się za darmo",
      features: [
        {
          icon: <FaCommentDots />,
          title: "AI‑asystent podróży",
          desc: "Porozmawiaj z inteligentnym asystentem, aby wymyślić swoją idealną podróż.",
          img: "/screenshots/chat_ai_assistant.jpg",
        },
        {
          icon: <FaMapLocationDot />,
          title: "Generator trasy",
          desc: "Stwórz spersonalizowaną trasę zgodnie z życzeniami i ograniczeniami.",
          img: "/screenshots/itinerary_chat.jpg",
        },
        {
          icon: <FaPlane />,
          title: "Transport, hotele & atrakcje",
          desc: "Porównuj i rezerwuj bezpośrednio to, czego potrzebujesz.",
          img: "/screenshots/transport_panel.jpg",
        },
        {
          icon: <FaMapPin />,
          title: "Interaktywna mapa",
          desc: "Zobacz swoją trasę, przystanki i sugestie na mapie.",
          img: "/screenshots/itinerary_page.jpg",
        },
      ],
      bottom: "Szukasz nowego sposobu na planowanie podróży?",
      bottom_description: [
        "Aplikacja nie jest jeszcze dostępna online, ale ciężko nad nią pracujemy!",
        "Szukamy ciekawych i zmotywowanych podróżników, którzy przetestują pierwsze wersje i powiedzą nam, co naprawdę się dla nich liczy.",
        "Tworząc bezpłatne konto pomagasz nam stworzyć idealne narzędzie podróżnicze i kształtować razem z nami przyszłość planowania podróży.",
      ],
    },
    el: {
      title: "Σχεδιάστε το ταξίδι σας με τη βοήθεια της AI",
      subtitle:
        "Μια έξυπνη εφαρμογή για να οργανώσετε το ιδανικό ταξίδι σας: διαδρομές, μεταφορές, καταλύματα, ενοικίαση αυτοκινήτων, δραστηριότητες…",
      cta: "Εγγράφομαι δωρεάν",
      features: [
        {
          icon: <FaCommentDots />,
          title: "Βοηθός ταξιδιού με AI",
          desc: "Συζητήστε με έναν έξυπνο βοηθό για να φανταστείτε το ιδανικό σας ταξίδι.",
          img: "/screenshots/chat_ai_assistant.jpg",
        },
        {
          icon: <FaMapLocationDot />,
          title: "Γεννήτρια διαδρομών",
          desc: "Δημιουργήστε ένα εξατομικευμένο δρομολόγιο σύμφωνα με τις επιθυμίες και τους περιορισμούς σας.",
          img: "/screenshots/itinerary_chat.jpg",
        },
        {
          icon: <FaPlane />,
          title: "Μεταφορές, ξενοδοχεία & δραστηριότητες",
          desc: "Συγκρίνετε και κλείστε απευθείας ό,τι χρειάζεστε.",
          img: "/screenshots/transport_panel.jpg",
        },
        {
          icon: <FaMapPin />,
          title: "Διαδραστικός χάρτης",
          desc: "Δείτε τη διαδρομή σας, στάσεις και προτάσεις στον χάρτη.",
          img: "/screenshots/itinerary_page.jpg",
        },
      ],
      bottom: "Ψάχνετε έναν νέο τρόπο να σχεδιάσετε τα ταξίδια σας;",
      bottom_description: [
        "Η εφαρμογή δεν είναι ακόμα διαθέσιμη, αλλά εργαζόμαστε σκληρά πάνω σε αυτήν!",
        "Αναζητούμε ταξιδιώτες περίεργους και κινητοποιημένους να δοκιμάσουν τις πρώτες εκδόσεις και να μας πουν τι πραγματικά έχει σημασία για αυτούς.",
        "Δημιουργώντας έναν δωρεάν λογαριασμό, μας βοηθάτε να κατασκευάσουμε το ιδανικό εργαλείο ταξιδιού και να διαμορφώσουμε μαζί το μέλλον του travel planning.",
      ],
    },
    da: {
      title: "Planlæg din rejse med hjælp fra AI",
      subtitle:
        "En intelligent app til at organisere din drømmerejse: rejseplaner, transport, overnatning, billeje, aktiviteter…",
      cta: "Tilmeld mig gratis",
      features: [
        {
          icon: <FaCommentDots />,
          title: "AI‑rejseassistent",
          desc: "Tal med en intelligent assistent for at designe din ideelle rejse.",
          img: "/screenshots/chat_ai_assistant.jpg",
        },
        {
          icon: <FaMapLocationDot />,
          title: "Rejseplan‑generator",
          desc: "Opret en personlig rejseplan ud fra dine ønsker og behov.",
          img: "/screenshots/itinerary_chat.jpg",
        },
        {
          icon: <FaPlane />,
          title: "Transport, hoteller & aktiviteter",
          desc: "Sammenlign og book det, du har brug for – direkte i appen.",
          img: "/screenshots/transport_panel.jpg",
        },
        {
          icon: <FaMapPin />,
          title: "Interaktivt kort",
          desc: "Se din rute, stop og forslag direkte på kortet.",
          img: "/screenshots/itinerary_page.jpg",
        },
      ],
      bottom: "Leder du efter en ny måde at planlægge dine rejser på?",
      bottom_description: [
        "Appen er endnu ikke live, men vi arbejder hårdt på det!",
        "Vi søger nysgerrige og engagerede rejsende til at teste de første versioner og fortælle os, hvad der virkelig betyder noget for dem.",
        "Ved at oprette en gratis konto hjælper du os med at skabe det ideelle rejseværktøj og forme fremtiden for rejseplanlægning sammen med os.",
      ],
    },
  };

  const get_text = () => {
    const language = navigator.language.split("-")[0];
    return texts[language as keyof typeof texts] || texts["en"];
  };

  useEffect(() => {
    setContent(get_text());
  }, []);

  return (
    <div className="bg-light">
      {content && (
        <div className="container px-4 py-5">
          {/* HERO */}

          <section className="text-center mb-5">
            <img
              src="/logos/logo_vivanoda_ai.svg"
              alt="Logo"
              height="50"
              className="mb-2"
            />
            <h1 className="display-4 fw-bold">{content.title}</h1>
            <p className="lead mt-3">{content.subtitle}</p>
            <Link
              className="btn btn-secondary btn-lg px-5"
              to={routes.register.path}
            >
              <span className="d-flex align-items-center">
                {content.cta}
                <FaAngleRight size={18} className="ms-3" />
              </span>
            </Link>
          </section>

          {/* FONCTIONNALITÉS */}

          <section className="">
            <div className="row g-5">
              {content.features.map((feature: any, idx: number) => (
                <div key={idx} className="col-12 col-md-6">
                  <div className="card h-100 border-0 bg-light">
                    <div
                      className="ratio ratio-16x9 overflow-hidden image-hover shadow rounded-4 "
                      onClick={() => handleImageClick(feature.img)}
                      role="button"
                      // style={{ maxHeight: "250px"}}
                    >
                      <img
                        src={feature.img}
                        alt={feature.title}
                        className="card-img-bottom w-100 h-100 object-fit-cover"
                        style={{ objectPosition: "center" }}
                      />
                    </div>
                    <div className="card-body">
                      <h5 className="card-title fs-5 fw-bold">
                        <span className="me-2">{feature.icon}</span>
                        {feature.title}
                      </h5>
                      <p className="card-text text-muted">{feature.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Modal Bootstrap */}
          {modalImage && (
            <>
              <div
                className="modal show fade d-block"
                tabIndex={-1}
                role="dialog"
                onClick={closeModal}
              >
                <div
                  className="modal-dialog modal-dialog-centered modal-xl"
                  role="document"
                >
                  <div className="modal-content bg-transparent border-0">
                    <div className="modal-body p-0 position-relative">
                      <button
                        type="button"
                        className="btn-close position-absolute top-0 end-0 m-3"
                        onClick={closeModal}
                        aria-label="Close"
                      ></button>
                      <img
                        src={modalImage}
                        alt="Feature zoom"
                        className="w-100 rounded"
                        style={{ maxHeight: "80vh", objectFit: "contain" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* backdrop */}
              <div className="modal-backdrop fade show"></div>
            </>
          )}

          {/* CTA FINAL */}
          <section className="text-center mt-5">
            <h4 className="mb-3">{content.bottom}</h4>
            <div className="lead">
              <p>
                {content.bottom_description[0]}
                <br />
                {content.bottom_description[1]}
                <br />
                {content.bottom_description[2]}
                <br />
              </p>
            </div>

            <Link
              className="btn btn-secondary btn-lg px-5"
              to={routes.register.path}
            >
              <span className="d-flex align-items-center">
                {content.cta}
                <FaAngleRight size={18} className="ms-3" />
              </span>
            </Link>
          </section>
        </div>
      )}
    </div>
  );
};

export default LandingPage;
